import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, isValid, reset, touch, focus } from 'redux-form';

import * as userActions from 'modules/user';
import * as currentStatusActions from 'modules/currentStatus';

import * as validFunc from 'libs/validation';
import { userEmailAsyncValidate } from 'libs/validation';
import * as adminLib from 'libs/adminLib';
import * as commonVar from 'libs/commonVar';

import { UserEdit } from 'components';

const reduxFormName = 'userEdit';

class CtUserEdit extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: true,
      errorMessage: ''
    };
  }

  componentDidMount() {
    const { addMode, isAuth } = this.props;
    // 관리자의 경우만 사용자 정보 수정(개인정보 접근) 로그
    if (isAuth === 2 && !addMode) {
      this.isUserLog();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { invalid, editResetNow, editSaveNow, setEditInvalid, setDisableSave } = this.props;
    const { formStore } = nextProps;

    if (invalid !== nextProps.invalid && typeof setEditInvalid === 'function') {
      setEditInvalid(nextProps.invalid);
    }

    if (nextProps.editResetNow && nextProps.editResetNow !== editResetNow) {
      this.resetUser();
    }

    if (nextProps.editSaveNow && nextProps.editSaveNow !== editSaveNow) {
      if (nextProps.invalid) {
        if (typeof setDisableSave === 'function') {
          setDisableSave(true);
        }
        this.markFieldValidate(reduxFormName);
      } else {
        this.saveUser();
      }
    }

    if (formStore && formStore.fields) {
      const errorType = ['syncErrors', 'syncWarnings', 'asyncErrors', 'asyncWarnings'];

      let anyError = false;
      for (const field in formStore.fields) {
        if (
          formStore.fields.hasOwnProperty(field) &&
          formStore.fields[field].touched &&
          formStore.fields[field].visited &&
          formStore.registeredFields[field] &&
          formStore.registeredFields[field].count > 0
        ) {
          for (let i = 0, l = errorType.length; i < l; i++) {
            if (formStore[errorType[i]] && formStore[errorType[i]][field]) {
              anyError = true;
              if (typeof setDisableSave === 'function') {
                setDisableSave(true);
              }
              break;
            }
          }
        }
        if (anyError) {
          break;
        }
      }

      if (!anyError) {
        if (typeof setDisableSave === 'function') {
          setDisableSave(false);
        }
      }
    }
  }

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 사용자 수정 클릭시 로그
  isUserLog = async () => {
    const { userInfo } = this.props;
    await adminLib.accessUserPut({ userNo: userInfo.userNo });
  };

  markFieldValidate = formName => {
    const { dispatch, formStore } = this.props;

    if (formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          if (formStore.registeredFields[field].count > 0) {
            dispatch(focus(formName, field));
            dispatch(touch(formName, field));
          }
        }
      }
    }
  };

  resetUser = () => {
    this.setState({ errorMessage: '' });

    const { dispatch, dispatchInitReset } = this.props;
    dispatch(reset(reduxFormName));
    if (typeof dispatchInitReset === 'function') {
      dispatchInitReset();
    }
  };

  saveUser = async () => {
    const { formUserEditIsValid, addMode, invalid, setEditOnProgress, handleOnToggleEditModal } = this.props;

    if (typeof setEditOnProgress === 'function') {
      setEditOnProgress(true);
    }
    this.setState({ onProgress: true });

    if (!!formUserEditIsValid && !invalid) {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      const { isAuth, formStore, userInfo, UserActions } = this.props;

      const params = {};
      if (formStore && formStore.values && formStore.registeredFields) {
        for (const field in formStore.registeredFields) {
          if (formStore.registeredFields.hasOwnProperty(field)) {
            if (formStore.registeredFields[field].count > 0) {
              if (typeof formStore.values[field] !== 'undefined' && formStore.values[field] !== userInfo[field]) {
                params[field] = formStore.values[field];
              }
            }
          }
        }
      }

      let preparedParams = false;
      if (Object.keys(params).length > 0) {
        if (!!!userInfo.userNo && addMode && isAuth === 2) {
          preparedParams = true;
        } else if (userInfo.userNo) {
          params.userNo = userInfo.userNo;
          preparedParams = true;
        } else {
          //
        }
      }

      if (preparedParams) {
        //
        try {
          let respObj = '';
          if (addMode) {
            respObj = await UserActions.addUser(params);
          } else {
            respObj = await UserActions.updateUser(params);
          }
          if (respObj && respObj.status && respObj.status === 200) {
            // 일반사용자일때만(내정보 수정) SnackBar에 문구 표시
            if (isAuth === 1) {
              //
              if (!!respObj.data && !!respObj.data.error && respObj.data.error[0].result === 'Duplicate User Exist') {
                // 중복되는 메일 존재
                this.setState({
                  errorMessage: defineMessages(
                    formatMessage({ id: 'vali_22', defaultMessage: '이미 등록된 이메일입니다.' })
                  )
                });
              } else {
                this.onToggleSnackbar(
                  defineMessages(formatMessage({ id: 'CtUserEdit_1', defaultMessage: '내 정보가 수정되었습니다.' }))
                );

                setTimeout(() => {
                  const { dispatchReset } = this.props;
                  dispatchReset();
                }, 500);
              }
              // 관리자 일때
            } else {
              if (!!respObj.data && !!respObj.data.error && respObj.data.error[0].result === 'Duplicate User Exist') {
                this.handleOnOpenEditModal();
                this.setState({
                  errorMessage: defineMessages(
                    formatMessage({ id: 'vali_22', defaultMessage: '이미 등록된 이메일입니다.' })
                  )
                });
                return false;
              }
            }
          } else {
            // 응답 오류
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        // 업데이트 할 것이 없음
      }
      if (typeof handleOnToggleEditModal === 'function') {
        handleOnToggleEditModal();
      }
    } else {
      // invalid
      const { formStore } = this.props;
      window.markFieldValidate(formStore, reduxFormName);
    }

    if (typeof handleOnToggleEditModal !== 'function' && typeof this.handleOnOpenEditModal === 'function') {
      this.handleOnOpenEditModal();
    }
  };

  //
  handleOnOpenEditModal = () => {
    const { setEditOnProgress } = this.props;

    if (typeof setEditOnProgress === 'function') {
      setEditOnProgress(false);
    }
    this.setState({ onProgress: false });
  };

  // 사용자 이메일 변경 메일 재전송
  handleUserEmailReSend = async () => {
    const { formatMessage } = this.props.intl;
    const { UserActions, isAuth } = this.props;
    let respObj = '';

    // 일반사용자
    if (isAuth === 1) {
      respObj = await UserActions.userChangeEmailReSend();

      setTimeout(() => {
        const { dispatchReset } = this.props;
        dispatchReset();
      }, 500);

      // 관리자
    } else {
      const { userInfo } = this.props;

      respObj = await UserActions.userChangeEmailReSend({ userNo: userInfo.userNo });
    }
    if (respObj && respObj.status && respObj.status === 200) {
      this.onToggleSnackbar(
        defineMessages(formatMessage({ id: 'CtUserEdit_2', defaultMessage: '이메일 변경 메일 재전송 성공' }))
      );

      // setTimeout(() => {
      //   const { dispatchReset } = this.props;
      //   dispatchReset();
      // }, 500);
    }
  };

  // 사용자 이메일 변경 취소
  handleUserEmailCancel = async () => {
    const { UserActions, isAuth } = this.props;
    // 일반사용자
    if (isAuth === 1) {
      await UserActions.userChangeEmailCancel();

      setTimeout(() => {
        const { dispatchReset } = this.props;
        dispatchReset();
      }, 500);

      // 관리자
    } else {
      const { userInfo } = this.props;

      await UserActions.userChangeEmailCancel({ userNo: userInfo.userNo });
    }
  };

  render() {
    const { onProgress, errorMessage } = this.state;
    const { addMode, isAuth, formStore, invalid, userInfo, handleOnToggleEditModal } = this.props;
    const { handleOnOpenEditModal, saveUser, handleUserEmailReSend, handleUserEmailCancel } = this;

    return (
      <UserEdit
        addMode={addMode}
        isAuth={isAuth}
        onProgress={onProgress}
        formStore={formStore}
        invalid={invalid}
        userInfo={userInfo}
        saveUser={saveUser}
        errorMessage={errorMessage}
        handleOnOpenEditModal={handleOnOpenEditModal}
        handleOnToggleEditModal={handleOnToggleEditModal}
        handleUserEmailReSend={handleUserEmailReSend}
        handleUserEmailCancel={handleUserEmailCancel}
      />
    );
  }
}

CtUserEdit.propTypes = {
  userInfo: PropTypes.object
};
CtUserEdit.defaultProps = {
  userInfo: {}
};

const mapStateToProps = (state, props) => {
  const { userInfo } = props;

  return {
    initialValues: userInfo,
    formStore: state.form[reduxFormName],
    formUserEditIsValid: isValid(reduxFormName)(state),
    isAuth: state.user.get('isAuth'),
    needReload: state.user.get('needReload')
  };
};

const mapDispatchToProps = dispatch => ({
  UserActions: bindActionCreators(userActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: reduxFormName,
    asyncValidate: userEmailAsyncValidate,
    asyncBlurFields: ['userEmail'],
    enableReinitialize: true,
    touchOnChange: true
  })(injectIntl(CtUserEdit))
);



// WEBPACK FOOTER //
// ./src/script/containers/user/CtUserEdit.js